<template>
  <div class="cyberCommand">
    <div class="feil_menu">
      <div class="feil_menu_title">Cyber Command</div>
      <div class="feil_menu_item">
        <el-tree
          :data="feilListData"
          node-key="id"
          :props="defaultProps"
          @node-click="handleNodeClick"
          :default-expanded-keys="unfoldArr"
          accordion
          :highlight-current="true"
          ref="tree"
        >
        <span class="span-ellipsis" slot-scope="{ node, data }">
        <span :title="node.label">{{ node.label }}</span>
        </span>
        </el-tree>
      </div>
    </div>
    <div class="feil_main">
      <div class="feil_main_title">{{ this.mainTitle }}</div>
      <div class="feil_main_item" v-if="fileMainItemData&&fileMainItemData.length>0">
        <ul class="feil_main_item_ul">
          <li
            v-for="val in this.fileMainItemData"
            :key="val.id"
            class="feil_main_item_li"
          >
            <div class="content" @click="downFeil(val.fileUrl,val.fileType)">
              <div class="content_icon">
                <img
                  :src="fileImg.ppt"
                  alt="ppt"
                  v-if="val.fileType == 'pptx'"
                />
                <img
                  :src="fileImg.doc"
                  alt="doc"
                  v-else-if="val.fileType == 'doc'"
                />
                <img
                  :src="fileImg.pdf"
                  alt="pdf"
                  v-else-if="val.fileType == 'pdf'"
                />
                <svg-icon
                  icon-class="image"
                  v-else-if="val.fileType == 'jpg' || val.fileType == 'png'"
                />
                <svg-icon icon-class="XLS" v-else-if="val.fileType == 'xlsx'" />
                <svg-icon
                  icon-class="video"
                  v-else-if="val.fileType == 'video'"
                />
              </div>
              <div class="content_title">
                <p>{{ val.fileName }}</p>
              </div>
              <div class="content_down">
                <svg-icon icon-class="download" v-if="val.fileType != 'link'&&val.fileType != 'video'" />
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="feil_main_item" v-else>
        <div class="noDetail">
          <svg-icon icon-class="nodeta"/>
          <p>No Data</p>
        </div>
      </div>
      <el-pagination
        layout="prev, pager, next"
        :total="pagination.total"
        :page-size="pagination.pageSize"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getCurrentHost } from '@/utils/index.js'
export default {
  name: "cyberCommand",
  data() {
    return {
      showItem: 1,
      mainTitle: "Cyber Command Main Slides",
      unfoldArr: [1],
      pagination: {
        page: 0,
        pageSize: 8,
        total: 0,
        data: [],
      },
      fileMainItemData: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      feilListData: [
        {
          label: "Product Introduction",
          id: 1,
          children: [
            { label: "Cyber Command Main Slides", child_id: 1, id: 20 },
            { label: "Cyber Command Positioning", child_id: 2 },
          ],
        },
        {
          label: "Sales Guidance",
          id: 2,
          children: [
            { label: "Cyber Command vs SIEM", child_id: 3 },
            { label: "Cyber Command Sales Guide", child_id: 4 },
            { label: "Cyber Command Brochure", child_id: 5 },
            { label: "Case Study", child_id: 6 },
          ],
        },
        {
          label: "Battle Card",
          id: 3,
          children: [
            // { label: "Cyber Command vs Darktrace Enterprise Immune System", child_id: 7},
            // { label: "Cyber Command vs PA Cortex XDR", child_id: 8 },
            // { label: "Competitive Analysis - Darktrace", child_id: 9 },
            // { label: "Competitive Analysis - Palo Alto", child_id: 10},
            // { label: "Cyber Command vs FireEye", child_id: 11},
            // { label: "Cyber Command vs Vectra", child_id: 12},
            // { label: "Cyber Command vs ExtraHop", child_id: 13},
            { label: "Sales Battle Cards", child_id: 7},
          ],
        },
        {
          label: "Sizing Guide",
          id: 4,
          children: [
            { label: "Cyber Command Sizing Guide", child_id: 14 },
            { label: "Cyber Command Datasheet", child_id: 15 },
            { label: "White Paper", child_id: 16 },
          ],
        },
        {
          label: "POC Docs",
          id: 5,
          children: [],
        },
        {
          label: "Bidding Doc",
          id: 6,
          children: [{ label: "Tender Specs", child_id: 17 }],
        },
        {
          label: "Technical Material",
          id: 7,
          children: [
            { label: "Solution Proposal", child_id: 18 },
            { label: "Online Demo", child_id: 19 },
            { label: "Whiteboard", child_id: 20 },
            { label: "Detection Capabilities Demo", child_id: 21 },
          ],
        },
        {
          label: "Training Docs",
          id: 8,
          children: [{ label: "FAQ", child_id: 22 }],
        },
      ],
      feilIndexData: {
        1: [
          {
            id: 1,
            fileName: "Cyber Command_PP_P_Cyber Command main slides.pptx",
            fileUrl:
              "Cyber Command_PP_P_Cyber Command main slides.pptx",
            fileType: "pptx",
          },
        ],
        2: [
          {
            id: 1,
            fileName: "CC_BR_P_Cyber Command Positioning_20210513.pdf",
            fileUrl:
              "CC_BR_P_Cyber Command Positioning_20210513.pdf",
            fileType: "pdf",
          },
        ],
        3: [
          {
            id: 1,
            fileName: "Sangfor_CP_P_Cyber-Command-and-SIEMs.pdf",
            fileUrl:
              "Sangfor_CP_P_Cyber-Command-and-SIEMs.pdf",
            fileType: "pdf",
          },
        ],
        4: [
          {
            id: 1,
            fileName: "CC_BR_P_Cyber Command Sales Scenarios.pdf",
            fileUrl:
              "CC_BR_P_Cyber Command Sales Scenarios.pdf",
            fileType: "pdf",
          },
        ],
        5: [
          {
            id: 1,
            fileName: "Cyber Command_BR_P_Product-Introduction.pdf",
            fileUrl:
              "Cyber Command_BR_P_Product-Introduction.pdf",
            fileType: "pdf",
          },
        ],
        6: [
          {
            id: 1,
            fileName: "Case Study_BR_P_Smart Car Hardware Vendo_20210207.pdf",
            fileUrl:
              "Case Study_BR_P_Smart Car Hardware Vendo_20210207.pdf",
            fileType: "pdf",
          },
        ],
        7: [
          {
            id: 1,
            fileName: "Sangfor_CP_P_Cyber-Command-VS-Darktrace_20200403-v2.pdf",
            fileUrl:
              "Sangfor_CP_P_Cyber-Command-VS-Darktrace_20200403-v2.pdf",
            fileType: "pdf",
          },
          {
            id: 2,
            fileName: "Cyber-Command-VS-Cortex XDR.pdf",
            fileUrl:
              "Cyber-Command-VS-Cortex XDR.pdf",
            fileType: "pdf",
          },
           {
            id: 3,
            fileName: "Competitive-Analysis-Darktrace.pdf",
            fileUrl:
              "Competitive-Analysis-Darktrace.pdf",
            fileType: "pdf",
          },
          {
            id: 4,
            fileName: "Competitive-Analysis-Palo-Alto-Cortex-XDR.pdf",
            fileUrl:
              "Competitive-Analysis-Palo-Alto-Cortex-XDR.pdf",
            fileType: "pdf",
          },
          {
            id: 5,
            fileName: "APT Solution- Sangfor vs. FireEye R3.pdf",
            fileUrl:
              "APT Solution- Sangfor vs. FireEye R3.pdf",
            fileType: "xlsx",
          },
          {
            id: 6,
            fileName:
              "Sangfor Cyber Command vs. Vectra Cognito Platform.pdf",
            fileUrl:
              "Sangfor Cyber Command vs. Vectra Cognito Platform.pdf",
            fileType: "pdf",
          },
           {
            id: 7,
            fileName: "Sangfor_CP_I_Sangfor Cyber Command VS ExtraHop Reveal(x)_20210715R5.pdf",
            fileUrl:
              "Sangfor_CP_I_Sangfor Cyber Command VS ExtraHop Reveal(x)_20210715R5.pdf",
            fileType: "pdf",
          },
        ],
        // 8: [
        //   {
        //     id: 1,
        //     fileName: "Cyber-Command-VS-Cortex XDR.pdf",
        //     fileUrl:
        //       "Cyber-Command-VS-Cortex XDR.pdf",
        //     fileType: "pdf",
        //   },
        // ],
        // 9: [
        //   {
        //     id: 1,
        //     fileName: "Competitive-Analysis-Darktrace.pdf",
        //     fileUrl:
        //       "Competitive-Analysis-Darktrace.pdf",
        //     fileType: "pdf",
        //   },
        // ],
        // 10: [
        //   {
        //     id: 1,
        //     fileName: "Competitive-Analysis-Palo-Alto-Cortex-XDR.pdf",
        //     fileUrl:
        //       "Competitive-Analysis-Palo-Alto-Cortex-XDR.pdf",
        //     fileType: "pdf",
        //   },
        // ],
        // 11: [
        //   {
        //     id: 1,
        //     fileName: "APT Solution- Sangfor vs. FireEye R3.pdf",
        //     fileUrl:
        //       "APT Solution- Sangfor vs. FireEye R3.pdf",
        //     fileType: "xlsx",
        //   },
        // ],
        // 12: [
        //   {
        //     id: 1,
        //     fileName:
        //       "Sangfor Cyber Command vs. Vectra Cognito Platform.pdf",
        //     fileUrl:
        //       "Sangfor Cyber Command vs. Vectra Cognito Platform.pdf",
        //     fileType: "pdf",
        //   },
        // ],
        // 13: [
        //   {
        //     id: 1,
        //     fileName: "Sangfor_CP_I_Sangfor Cyber Command VS ExtraHop Reveal(x)_20210715R5.pdf",
        //     fileUrl:
        //       "Sangfor_CP_I_Sangfor Cyber Command VS ExtraHop Reveal(x)_20210715R5.pdf",
        //     fileType: "pdf",
        //   },
        // ],
        14: [
          {
            id: 1,
            fileName: "Cyber Command Sizing Guide.xlsx",
            fileUrl:
              "Cyber Command Sizing Guide.xlsx",
            fileType: "xlsx",
          },
        ],
        15: [
          {
            id: 1,
            fileName: "Cyber Command _DS_P_Cyber-Command-Datasheet _20210513.pdf",
            fileUrl:
              "Cyber Command _DS_P_Cyber-Command-Datasheet _20210513.pdf",
            fileType: "pdf",
          },
        ],
        16:[
          {
            id: 1,
            fileName: "WP_Cyber Command Whitepaper.pdf",
            fileUrl: "WP_Cyber Command Whitepaper.pdf",
            fileType: "pdf",
          },
        ],
        17:[
          {
            id: 1,
            fileName: "CC tender spec screenshots.docx",
            fileUrl: "CC tender spec screenshots.docx",
            fileType: "doc",
          },
          {
            id: 2,
            fileName: "Cyber Command Tender.docx",
            fileUrl: "Cyber Command Tender.docx",
            fileType: "doc",
          },
          {
            id: 3,
            fileName: "STA Tender.docx",
            fileUrl: "STA Tender.docx",
            fileType: "doc",
          },
        ],
        18:[
          {
            id: 1,
            fileName: "Cyber Command Solution proposal.docx",
            fileUrl: "Cyber Command Solution proposal.docx",
            fileType: "doc",
          },
        ],
        19: [
          {
            id: 1,
            fileName: "Online Demo",
            fileUrl: "https://www.youtube.com/watch?v=mmJNemH3yhU",
            fileType: "video",
          },
        ],
        20: [
          {
            id: 1,
            fileName: "Whiteboard",
            fileUrl: "https://youtu.be/G_fSgtjvHOY",
            fileType: "video",
          },
        ],
        21: [
          {
            id: 1,
            fileName: "Detection Capabilities Demo",
            fileUrl: "https://youtu.be/iuXjXxscusQ",
            fileType: "video",
          },
        ],
        22: [
          {
            id: 1,
            fileName: "FAQ  IMD.xlsx",
            fileUrl:
              "FAQ  IMD.xlsx",
            fileType: "xlsx",
          },
        ],
      },
      fileImg: {
        ppt: require("../../../assets/img/ppt.png"),
        doc: require("../../../assets/img/doc.png"),
        pdf: require("../../../assets/img/pdf.png"),
      },
    };
  },
  methods: {
    handleNodeClick(data) {
      console.log(data);
      if (data.child_id) {
        this.showItem = data.child_id;
        this.mainTitle = data.label;
        this.pagination.total = this.feilIndexData[data.child_id].length;
        this.fileMainItemData = this.feilIndexData[data.child_id];
        this.pagination.data = this.feilIndexData[data.child_id];
        if (this.pagination.total > 8) {
          this.fileMainItemData = this.fileMainItemData.slice(0, 8);
        }
      }else if(data.children&&data.children.length==0){
        this.fileMainItemData =[];
      }
    },
    handleCurrentChange(val) {
      let sliceEnd = val * 8;
      let sliceStart = sliceEnd - 8;
      this.fileMainItemData = this.pagination.data.slice(sliceStart, sliceEnd);
    },
    //初始化渲染
    initRender() {
      if (this.feilIndexData[1].length > 8) {
        this.pagination.total = this.feilIndexData[1].length;
        this.pagination.data = this.feilIndexData[1];
        this.fileMainItemData = this.feilIndexData[1].slice(0, 8);
      } else {
        this.pagination.total = this.feilIndexData[1].length;
        this.pagination.data = this.feilIndexData[1];
        this.fileMainItemData = this.feilIndexData[1];
      }
    },
    downFeil(item,type) {
      if(type!='video'){
        var a = document.createElement("a");
        var filename = item;
        a.href = "http://" + item.fileUrl;
        a.href =getCurrentHost()+ item;
        a.download = filename;
        a.click();
      }else{
        window.open(item);
      } 
    },
  },
  mounted() {
    this.initRender();
    this.$nextTick(() => {
      this.$refs.tree.setCurrentKey(20);
    });
  },
};
</script>

<style scoped lang="scss">
.cyberCommand {
  width: 100%;
  padding: 5px 17px;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  .feil_menu {
    width: 20%;
    background: #1688e1;
    .feil_menu_title {
      width: 100%;
      padding: 15px 0;
      font-size: 16px;
      font-weight: 600;
      color: #eaf3f4;
    }
  }
  .feil_main {
    width: 79.5%;
    background: #eff6ff;
    .feil_main_title {
      width: 100%;
      height: 46px;
      background: #1688e1;
      line-height: 46px;
      font-size: 16px;
      text-align: left;
      padding: 0 40px;
      color: #eaf3f4;
    }
    .feil_main_item {
      width: 100%;
      height: 680px;
      padding: 10px;
      .feil_main_item_ul {
        width: 100%;
        .feil_main_item_li {
          padding: 10px;
          .content {
            width: 100%;
            display: flex;
            background: #fff;
            padding: 10px 20px;
            border-radius: 8px;
            justify-content: space-between;
            .content_icon {
              width: 4.5%;
              height: 42px;
              margin-right: 15px;
              background: #248fe6;
              border-radius: 4px;
              display: flex;
              align-items: center;
              justify-content: center;
              img {
                width: 100%;
              }
              .svg-icon {
                font-size: 28px;
                color: #fff;
                font-weight: 600;
              }
            }
            .content_down {
              width: 4%;
              display: flex;
              align-items: center;
              justify-content: center;
              .svg-icon {
                font-size: 24px;
                color: #248fe6;
              }
            }
            .content_title {
              width: 90%;
              display: flex;
              align-items: center;
              font-size: 14px;
              p {
                width: 100%;
                text-align: left;
                color: #248fe6;
                font-weight: 600;
              }
            }
          }
        }
      }
      .noDetail{
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        .svg-icon{
          font-size: 60px;
        }
        p{
          font-size: 14px;
        }
      }
    }
  }
}
</style>